module.exports = __webpack_public_path__ + "img/barabas_dora.c61dbb1a.jpg";